const partnerGoodsDispatch = {
    state:{
      // 当前页面选择类型
      partnerGoodsDispatchSetType:'1'
    },
    actions:{
      setPartnerGoodsDispatchSetType({ commit }, data) {
        commit("SET_GOODS_DISPATCH_SET_TYPE", data);
      },
    },
    mutations: {
      SET_PARTNER_GOODS_DISPATCH_SET_TYPE:(state, val) => {
        state.partnerGoodsDispatchSetType = val
      },
    }
}
export default partnerGoodsDispatch